import React from "react";

const NewsLetter = () => {
  return (
    <div className="flex flex-col items-start  sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        C.
        <span className="text-[#01A7D1] ">
          {" "}
          ELECTRONIC NEWSLETTERS, INVITATIONS, POLLS AND SURVEYS
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        At our sole discretion, Yostel may offer any of the following free
        services on the Platform, which you may select to use or receive at your
        option. Certain of the following services may require you to provide
        additional personal information as detailed below:
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. ELECTRONIC NEWSLETTERS
        </h1>
        We may offer a free electronic newsletter to users. We will gather the
        email addresses of users who sign up for Yostel for the newsletter
        mailing list. Users may remove themselves from this mailing list by
        opting out of receiving newsletters during the registration process, by
        following the link provided in each newsletter that points users to a
        subscription management page where the user can unsubscribe from
        receiving newsletters or by changing their preferences in their Profile
        Settings page.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. "SEND TO A FRIEND"
        </h1>
        Our Platform users can voluntarily choose to electronically forward a
        link, page, or document to someone else by clicking "send to a friend."
        To do so, the user must provide his or her email address, as well as the
        email address of the recipient. The user's email address is used only in
        the case of transmission errors and, of course, to let the recipient
        know who sent the email. The information is not used for any other
        purpose.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. POLLING
        </h1>
        We may offer interactive polls to users so they can easily share their
        opinions with other users and see what our audience thinks about
        important issues, Services, and/or the Platform. Opinions or other
        responses to polls are aggregated and are not identifiable to any
        particular user. We may use a system to "tag" users after they have
        voted, so they can vote only once on a particular question. This tag is
        not correlated with information about individual users.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          4. SURVEYS
        </h1>
        We may conduct user surveys from time to time to better target our
        content to our Platform users. We will not share individual responses
        from these surveys with any third party. We will share aggregate data
        with third party service providers, partners, and other third parties.
      </p>
    </div>
  );
};

export default NewsLetter;
